// Apolo IDE — S5 · useSubagentRuns hook.
//
// Lê os subagents S5 (explore/bash/browser) desta sessão do subagentRunStore
// via useSyncExternalStore — a rail reflete running→done sem polling.

import { useSyncExternalStore, useCallback } from 'react';
import { getSubagentRuns, subscribeSubagentRuns } from '../lib/subagentRunStore.js';

const EMPTY = [];

export default function useSubagentRuns(sessionId) {
  const subscribe = useCallback(
    (cb) => (sessionId ? subscribeSubagentRuns(sessionId, cb) : () => {}),
    [sessionId],
  );
  const getSnapshot = useCallback(
    () => (sessionId ? getSubagentRuns(sessionId) : EMPTY),
    [sessionId],
  );
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
